import { gql } from '@apollo/client';

import { PatientTagGroupsFragment } from './patientTagGroups.gql.types';

export const PATIENT_TAG_GROUPS_FRAGMENT = gql`
    fragment PatientTagGroups on Patient {
        tags {
            items {
                id
                name
                tagGroup {
                    id
                    name
                }
            }
        }
    }
`;

export type PatientTagGroup = { id: string; name: string; tagNames: string[] };

// Keyed by group id, since two groups can share a name. Group order follows first appearance, and
// tag order within a group follows input order.
export const groupTagNamesByGroup = (
    tags: NonNullable<PatientTagGroupsFragment['tags']>['items'],
): Map<string, PatientTagGroup> => {
    const grouped = new Map<string, PatientTagGroup>();
    for (const tag of tags) {
        const existing = grouped.get(tag.tagGroup.id);
        if (existing) {
            existing.tagNames.push(tag.name);
        } else {
            grouped.set(tag.tagGroup.id, {
                id: tag.tagGroup.id,
                name: tag.tagGroup.name,
                tagNames: [tag.name],
            });
        }
    }
    return grouped;
};
